<template>
  <div v-if="false" class="analytics-section">
    <!-- Заголовок секции -->
    <h2 class="section-title">Динамика просмотров курсов</h2>
    
    <!-- Основная карточка аналитики -->
    <div class="analytics-card">
      <!-- Подзаголовок -->
      <h3 class="card-subtitle">Просмотры</h3>
      
      <!-- Верхняя панель управления -->
      <div class="controls-panel">
        <!-- Кнопка перехода к аналитике -->
        <button class="analytics-button">
          <span>Перейти к аналитике</span>
          <i class="icon-arrow">→</i>
        </button>
        
        <!-- Фильтры -->
        <div class="filters-group">
          <div class="filter-item">
            <span class="filter-label">Курс</span>
            <button class="filter-dropdown">
              <i class="dropdown-icon">▼</i>
            </button>
          </div>
          
          <div class="filter-item">
            <span class="filter-label">Категория</span>
            <button class="filter-dropdown">
              <i class="dropdown-icon">▼</i>
            </button>
          </div>
          
          <div class="filter-item">
            <span class="filter-label">Период</span>
            <button class="filter-dropdown">
              <i class="dropdown-icon">▼</i>
            </button>
          </div>
        </div>
      </div>
      
      <!-- График -->
      <div class="chart-container">
        <!-- Ось Y с значениями -->
        <div class="chart-y-axis">
          <span class="y-value">400</span>
          <span class="y-value">350</span>
          <span class="y-value">300</span>
          <span class="y-value">250</span>
          <span class="y-value">200</span>
          <span class="y-value">150</span>
          <span class="y-value">100</span>
        </div>
        
        <!-- Область графика -->
        <div class="chart-area">
          <!-- Горизонтальные линии сетки -->
          <div class="chart-grid-horizontal">
            <div class="grid-line" v-for="i in 7" :key="`h-${i}`"></div>
          </div>
          
          <!-- Вертикальные линии сетки -->
          <div class="chart-grid-vertical">
            <div class="grid-line-vertical" v-for="i in 7" :key="`v-${i}`"></div>
          </div>
          
          <!-- Линия графика (можно заменить на canvas или svg) -->
          <img 
            class="chart-line" 
            src="/assets/animaapp/-------------------.png" 
            alt="График просмотров"
          />
        </div>
        
        <!-- Ось X с днями недели -->
        <div class="chart-x-axis">
          <span class="x-label">Пн</span>
          <span class="x-label">Вт</span>
          <span class="x-label">Ср</span>
          <span class="x-label">Чт</span>
          <span class="x-label">Пт</span>
          <span class="x-label">Сб</span>
          <span class="x-label">Вс</span>
        </div>
      </div>
      
      <!-- Выпадающие меню фильтров (показываются при клике) -->
      <div class="dropdown-menus">
        <!-- Меню выбора курса -->
        <div class="dropdown-menu course-menu" v-if="showCourseMenu">
          <div class="dropdown-item">Все</div>
          <div class="dropdown-item active">Курс: Обучение 1С и Битрикс</div>
          <div class="dropdown-item">Курс: Корпоративные стандарты</div>
          <div class="dropdown-item">Курс: Обучение по продукту</div>
        </div>
        
        <!-- Меню выбора категории -->
        <div class="dropdown-menu category-menu" v-if="showCategoryMenu">
          <div class="dropdown-item active">Техническая подготовка</div>
          <div class="dropdown-item">Продажи</div>
          <div class="dropdown-item">Управление и менеджмент</div>
          <div class="dropdown-item">Бизнес</div>
        </div>
        
        <!-- Меню выбора периода -->
        <div class="dropdown-menu period-menu" v-if="showPeriodMenu">
          <div class="dropdown-item active">Неделя</div>
          <div class="dropdown-item">Месяц</div>
          <div class="dropdown-item">Год</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AnalyticsSection",
  data() {
    return {
      showCourseMenu: false,
      showCategoryMenu: false,
      showPeriodMenu: false,
      chartData: {
        labels: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
        values: [150, 200, 250, 300, 280, 220, 180]
      },
      selectedCourse: 'Курс: Обучение 1С и Битрикс',
      selectedCategory: 'Техническая подготовка',
      selectedPeriod: 'Неделя'
    }
  },
  methods: {
    toggleCourseMenu() {
      this.showCourseMenu = !this.showCourseMenu;
      this.showCategoryMenu = false;
      this.showPeriodMenu = false;
    },
    toggleCategoryMenu() {
      this.showCategoryMenu = !this.showCategoryMenu;
      this.showCourseMenu = false;
      this.showPeriodMenu = false;
    },
    togglePeriodMenu() {
      this.showPeriodMenu = !this.showPeriodMenu;
      this.showCourseMenu = false;
      this.showCategoryMenu = false;
    },
    goToAnalytics() {
      // Логика перехода к детальной аналитике
      console.log('Переход к аналитике');
    }
  }
};
</script>

<style scoped>
/* Основной контейнер */
.analytics-section {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

/* Заголовок секции */
.section-title {
  color: rgba(0, 0, 0, 0.8);
  font-family: "Poppins", sans-serif;
  font-size: 30px;
  font-weight: 700;
  margin-bottom: 30px;
}

/* Карточка аналитики */
.analytics-card {
  background-color: #ffffff;
  border: 1px solid rgba(99, 99, 99, 0.4);
  border-radius: 20px;
  padding: 30px;
  position: relative;
  min-height: 800px;
}

/* Подзаголовок карточки */
.card-subtitle {
  color: rgba(0, 0, 0, 0.7);
  font-family: "Poppins", sans-serif;
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 20px;
}

/* Панель управления */
.controls-panel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
  flex-wrap: wrap;
  gap: 20px;
}

/* Кнопка аналитики */
.analytics-button {
  background-color: rgba(0, 149, 236, 0.8);
  color: #ffffff;
  border: none;
  border-radius: 15px;
  padding: 12px 24px;
  font-family: "Poppins", sans-serif;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: background-color 0.3s;
}

.analytics-button:hover {
  background-color: #0095ec;
}

.icon-arrow {
  font-style: normal;
  transform: rotate(-90deg);
}

/* Группа фильтров */
.filters-group {
  display: flex;
  gap: 30px;
  align-items: center;
}

/* Элемент фильтра */
.filter-item {
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
}

.filter-label {
  color: rgba(0, 0, 0, 0.7);
  font-family: "Poppins", sans-serif;
  font-size: 18px;
  font-weight: 500;
}

.filter-dropdown {
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dropdown-icon {
  color: rgba(0, 0, 0, 0.7);
  font-style: normal;
  font-size: 12px;
}

/* Контейнер графика */
.chart-container {
  position: relative;
  height: 500px;
  display: grid;
  grid-template-columns: 60px 1fr;
  grid-template-rows: 1fr 40px;
  gap: 10px;
}

/* Ось Y */
.chart-y-axis {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-right: 10px;
  grid-row: 1;
  grid-column: 1;
}

.y-value {
  color: rgba(0, 0, 0, 0.5);
  font-family: "Poppins", sans-serif;
  font-size: 16px;
  font-weight: 400;
  text-align: right;
}

/* Область графика */
.chart-area {
  position: relative;
  grid-row: 1;
  grid-column: 2;
  border-left: 2px solid rgba(0, 0, 0, 0.3);
  border-bottom: 2px dashed rgba(0, 0, 0, 0.2);
}

/* Сетка графика */
.chart-grid-horizontal {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.grid-line {
  height: 1px;
  background: url('~@/../public/assets/animaapp/line-28.svg') repeat-x;
  opacity: 0.3;
}

.chart-grid-vertical {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: space-between;
}

.grid-line-vertical {
  width: 1px;
  background: url('~@/../public/assets/animaapp/line-27-6.svg') repeat-y;
  opacity: 0.3;
}

/* Линия графика */
.chart-line {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  width: 100%;
  height: auto;
  z-index: 2;
}

/* Ось X */
.chart-x-axis {
  grid-row: 2;
  grid-column: 2;
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
}

.x-label {
  color: rgba(0, 0, 0, 0.5);
  font-family: "Poppins", sans-serif;
  font-size: 18px;
  font-weight: 400;
}

/* Выпадающие меню */
.dropdown-menus {
  position: absolute;
  top: 100px;
  right: 30px;
  z-index: 10;
}

.dropdown-menu {
  background-color: #ffffff;
  border: 1px solid rgba(99, 99, 99, 0.4);
  border-radius: 5px;
  box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.15);
  padding: 10px;
  margin-bottom: 10px;
  min-width: 150px;
}

.dropdown-item {
  color: rgba(0, 0, 0, 0.5);
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  font-weight: 400;
  padding: 8px 12px;
  cursor: pointer;
  transition: all 0.2s;
  border-radius: 3px;
}

.dropdown-item:hover {
  background-color: rgba(0, 149, 236, 0.1);
}

.dropdown-item.active {
  color: #000000;
  font-weight: 500;
  background-color: rgba(0, 149, 236, 0.05);
}

/* Адаптивность */
@media (max-width: 768px) {
  .controls-panel {
    flex-direction: column;
    align-items: stretch;
  }
  
  .filters-group {
    flex-direction: column;
    width: 100%;
    gap: 15px;
  }
  
  .chart-container {
    height: 400px;
    grid-template-columns: 40px 1fr;
  }
  
  .y-value {
    font-size: 14px;
  }
  
  .x-label {
    font-size: 14px;
  }
}
</style>